import sample_1 from './fleischer.jpg';

export const fleischerImpressions = {
    sample_1,
};
